import { createSlice } from '@reduxjs/toolkit';
import get from 'lodash/get';
import set from 'lodash/set';
import { parsePath } from 'actions/storefront-editor/utils';
import { editorSlice } from './editor';

const initialState = {
  header: [],
  content: [],
  footer: [],
  settings: {},
  pageMeta: { title: '', description: '' },
};

export const dataSlice = createSlice({
  name: 'storefrontEditor/data',
  initialState,
  reducers: {
    setData(state, { payload }) {
      Object.assign(state, payload);
    },

    addSection(state, { payload }) {
      const { path, section, index } = payload;
      const arr = get(state, path);
      if (!Array.isArray(arr)) return;
      arr.splice(index ?? arr.length, 0, section);
    },

    addBlock(state, { payload }) {
      const { path, block, index } = payload;
      if (!Array.isArray(get(state, path))) set(state, path, []);
      const arr = get(state, path);
      arr.splice(index ?? arr.length, 0, block);
    },

    removeNode(state, { payload }) {
      const { isBlock, group, sectionIndex, slotId, blockIndex } = parsePath(
        payload.path,
      );
      const arr = isBlock
        ? state[group]?.[sectionIndex]?.blocks?.[slotId]
        : state[group];
      arr?.splice(isBlock ? blockIndex : sectionIndex, 1);
    },

    moveNode(state, { payload }) {
      const from = parsePath(payload.fromPath);
      const to = parsePath(payload.toPath);
      const arr = from.isBlock
        ? state[from.group]?.[from.sectionIndex]?.blocks?.[from.slotId]
        : state[from.group];
      if (!arr) return;

      const fromIndex = from.isBlock ? from.blockIndex : from.sectionIndex;
      const toIndex = to.isBlock ? to.blockIndex : to.sectionIndex;
      if (fromIndex === toIndex) return;

      const [moved] = arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, moved);
    },

    toggleNode(state, { payload }) {
      const node = get(state, payload.path);
      if (!node) return;
      node.disabled = !node.disabled;
    },

    updateSetting(state, { payload }) {
      set(state, payload.path, payload.value);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(editorSlice.actions.loadPage, (state, { payload }) => {
      state.content = payload.content;
      state.pageMeta = payload.pageMeta;
    });
  },
});
